
import { Component, Vue } from "vue-property-decorator";
import ImageCropper from "@/views/ai-builder-v3/components/imageCropper.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";

@Component({
  components: {
    ImageCropper,
    InputNumberV3
  }
})
export default class Test extends Vue {
  file: any = null;
  fileList: any = [];

  form = {
    name: "",
    region: "",
    date1: "",
    date2: "",
    delivery: false,
    type: [],
    resource: "",
    desc: ""
  };
  num = "";
  num1 = "0";
  radio1 = "";

  getnum() {
    console.log(this.num1);
  }

  onChange(e: any) {
    debugger;
    this.file = e.srcElement.files[0];
  }

  // change(value: string) {
  //   console.log(value);
  // }

  cancel() {
    console.log("cancel");
  }

  confirm(base64: string) {
    console.log(base64);
  }
}
